<template>
<div class="chapter">
<div class="inner_page">
<section aria-label="Title Page">
<div class="ipadfp"><span aria-label=" page iii. " epub:type="pagebreak" id="page_iii" role="doc-pagebreak"><img alt="Lioness Rampant, by Tamora Pierce. Atheneum Books for Young Readers. New York | London | Toronto | Sydney | New Delhi." class="imagefp" src="e9781439132081/images/title.jpg"/></span></div>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// title.vue?e3dff9e4